import { throttle } from "lodash";
import { x0, isLargeDesktop, isMobile } from "../../../_helpers";

export default class StandingStickyHeader {
  poolsContainer = null;
  roundNavigation = null;
  rankingTable = null;
  rankingTableName = null;
  tableHead = null;
  primaryNav = null;
  secondaryNav = null;

  constructor() {
    const _this = this;
    this.lastScrollTop = 0;

    _this.init();
  }

  init() {
    const _this = this;
    _this.poolsContainer = x0('.vbw-pools-container, .vbw-rounds-container');
    _this.roundNavigation = _this.poolsContainer?.querySelector('.tabs-nav__content');

    if (!x0('[js-sticky-standings]')) return;

    _this.tablesContainer = x0('[js-sticky-standings]').childNodes;
    _this.primaryNav = x0('[js-primary-nav]');
    _this.secondaryNav = x0('[js-secondary-nav-v2]');

    if (isLargeDesktop()) {
      window.addEventListener(
        "scroll",
        throttle(() => _this.checkSticiyness(_this.tablesContainer), 300),
      );
    }
  }

  getNavigationHeight() {
    let _this = this;
    let primaryRectHeight = _this.primaryNav.getBoundingClientRect().height;

    //  To Check user scrolling direction
    const st = window.scrollY || document.documentElement.scrollTop;
    if (st > this.lastScrollTop) {
      // Going down from top to bottom

      if (!isMobile()) {
        primaryRectHeight = 0;
      }
    } else {
      // Going Up from bottom
    }
    this.lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling

    const secondaryRectHeight = _this.secondaryNav
      ? _this.secondaryNav.getBoundingClientRect().height
      : 0;
    return primaryRectHeight + secondaryRectHeight;
  }

  getActiveTHead(id = 0) {
    let _this = this;

    if (!_this.roundNavigation) {
      return null;
    }
    let activeRoundTab =
      _this.roundNavigation.querySelector(".tab-item.active");
    let activeRoundId = activeRoundTab ? activeRoundTab.dataset["tabId"] : "";

    if (!activeRoundId) {
      return null;
    }
    let activeRound = _this.poolsContainer.querySelector(
      '[data-tab="' + activeRoundId + '"]',
    );

    return activeRound
      ? activeRound.childNodes[id]?.querySelector("thead")
      : null;
  }

  checkSticiyness(wrapper) {
    let _this = this;
    const top = _this.getNavigationHeight();
    let theadTop = 0;
    let rankingTableHeight = 0;
    let theadHeight = 0;

    wrapper.forEach((wrap, id) => {
      _this.rankingTable = wrap.querySelector(".vbw-pool-ranking--tables");
      _this.rankingTableName = wrap.querySelector(
        ".vbw-pools-combined-name, .vbw-rounds-combined-name",
      );
      let thead = _this.getActiveTHead(id);
      let wrapRect = wrap.getBoundingClientRect();

      if (_this.rankingTable) {
        rankingTableHeight = _this.rankingTable.getBoundingClientRect().height;
      }
      if (thead) {
        theadHeight = thead.getBoundingClientRect().height;
      }

      // Check if specific table wrap in sticky zone
      if (
        top >= wrapRect.top &&
        top <= wrapRect.top + wrapRect.height - theadHeight - rankingTableHeight
      ) {
        if (_this.rankingTableName) {
          _this.applyStickiness(_this.rankingTableName, top, false);
        }

        if (_this.rankingTable) {
          _this.applyStickiness(_this.rankingTable, top, true);
        }

        if (thead) {
          theadTop = top + rankingTableHeight;
          _this.applyStickiness(thead, theadTop, true);
        }
      } else {
        _this.removeStickiness(wrap);
      }
    });
  }

  applyStickiness(el, top, isAddMargin) {
    let rect = el.getBoundingClientRect();
    let elHeight = rect.height;
    let parentWidth = el.parentNode.offsetWidth;

    if (top >= rect.top) {
      if (isAddMargin) {
        el.style.width = [parentWidth, "px"].join("");
        el.parentNode.style.marginTop = [elHeight, "px"].join("");
      }
      el.style.top = [top, "px"].join("");
      el.classList.add("sticky");
    }
  }

  removeStickiness(wrap) {
    wrap.querySelectorAll(".sticky").forEach((el) => {
      el.classList.remove("sticky");
      el.style.top = null;
      el.style.width = null;
      el.parentNode.style.marginTop = null;
    });
  }
}
